import React from "react";

function SmartHome() {
  return <div></div>;
}

export default SmartHome;
